'use client';

import { createContext, ReactNode, useContext } from 'react';
import type { IProps as IFormErrorProps } from '@creditflowresearch/uilib/Form/FormError/FormError';

interface IProps<T> {
  children: ReactNode,
  selectedValue: T,
  name?: string,
  disabled?: boolean,
  isErrorMessage?: boolean,
  onChange?: (selectedValue: T) => void,
  meta?: IFormErrorProps,
}

const createRadioGroupValues = <T = string | number | boolean>({
  name,
  disabled,
  isErrorMessage,
  selectedValue,
  onChange,
  meta,
}: Omit<IProps<T>, 'children'>) => {
  return {
    name,
    disabled,
    isErrorMessage,
    selectedValue,
    onChange,
    meta,
  };
};

type TRadioGroupContext = ReturnType<typeof createRadioGroupValues>;

export const RadioGroupContext = createContext<TRadioGroupContext>(null);

export const useRadioGroupContext = () => useContext(RadioGroupContext);

const RadioGroupContextProvider = <T = string | number | boolean>({
  children,
  name,
  disabled,
  isErrorMessage,
  selectedValue,
  onChange,
  meta,
}: IProps<T>) => (
  <RadioGroupContext.Provider value={ createRadioGroupValues<T>({
      name,
      disabled,
      isErrorMessage,
      selectedValue,
      onChange,
      meta,
    },
  ) }
  >
    { children }
  </RadioGroupContext.Provider>
);

export default RadioGroupContextProvider;
